var _rect, _rect2, _g, _g2, _g3, _g4, _g5, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKalisioKnowledge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 340",
    width: 600,
    height: 340,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 340,
    fill: "#f0fdf4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 560,
    height: 300,
    rx: 16,
    fill: "#dcfce7",
    opacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 80,
    width: 100,
    height: 180,
    rx: 10,
    fill: "#fff",
    stroke: "#059669",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 105,
    textAnchor: "middle",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10,
    fontWeight: 700,
    fill: "#064e3b"
  }, "CODEBASE"), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 120,
    width: 76,
    height: 6,
    rx: 2,
    fill: "#059669",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 132,
    width: 60,
    height: 4,
    rx: 2,
    fill: "#6b7280",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 142,
    width: 70,
    height: 4,
    rx: 2,
    fill: "#6b7280",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 152,
    width: 52,
    height: 4,
    rx: 2,
    fill: "#6b7280",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 168,
    width: 76,
    height: 6,
    rx: 2,
    fill: "#047857",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 180,
    width: 64,
    height: 4,
    rx: 2,
    fill: "#6b7280",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 190,
    width: 70,
    height: 4,
    rx: 2,
    fill: "#6b7280",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 206,
    width: 76,
    height: 6,
    rx: 2,
    fill: "#059669",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 218,
    width: 58,
    height: 4,
    rx: 2,
    fill: "#6b7280",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 228,
    width: 66,
    height: 4,
    rx: 2,
    fill: "#6b7280",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 238,
    width: 70,
    height: 4,
    rx: 2,
    fill: "#6b7280",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 270,
    r: 6,
    fill: "#047857"
  }), /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 287,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 8,
    fill: "#064e3b"
  }, "git history"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 168,
    y1: 170,
    x2: 208,
    y2: 170,
    stroke: "#059669",
    strokeWidth: 2,
    strokeDasharray: "3,3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208,170 200,165 200,175",
    fill: "#059669"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 90,
    width: 168,
    height: 160,
    rx: 12,
    fill: "#064e3b"
  }), /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 112,
    textAnchor: "middle",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10,
    fontWeight: 700,
    fill: "#6ee7b7"
  }, "KNOWLEDGE"), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 125,
    width: 140,
    height: 28,
    rx: 6,
    fill: "#047857"
  }), /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 143,
    textAnchor: "middle",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#fff"
  }, "RAG \xB7 Qdrant"), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 160,
    width: 140,
    height: 28,
    rx: 6,
    fill: "#059669"
  }), /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 178,
    textAnchor: "middle",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#fff"
  }, "Git Intelligence"), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 195,
    width: 140,
    height: 28,
    rx: 6,
    fill: "#047857"
  }), /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 213,
    textAnchor: "middle",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#fff"
  }, "Dependency Graph"), /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 240,
    textAnchor: "middle",
    fontFamily: "system-ui, sans-serif",
    fontSize: 9,
    fill: "#6ee7b7",
    opacity: 0.8
  }, "FastAPI \xB7 tree-sitter"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 392,
    y1: 170,
    x2: 432,
    y2: 170,
    stroke: "#059669",
    strokeWidth: 2,
    strokeDasharray: "3,3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432,170 424,165 424,175",
    fill: "#059669"
  }), /*#__PURE__*/React.createElement("text", {
    x: 412,
    y: 160,
    textAnchor: "middle",
    fontFamily: "system-ui, sans-serif",
    fontSize: 9,
    fontWeight: 700,
    fill: "#064e3b"
  }, "MCP"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 100,
    width: 100,
    height: 140,
    rx: 10,
    fill: "#fff",
    stroke: "#059669",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 490,
    y: 122,
    textAnchor: "middle",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10,
    fontWeight: 700,
    fill: "#064e3b"
  }, "AI AGENTS"), /*#__PURE__*/React.createElement("rect", {
    x: 452,
    y: 138,
    width: 76,
    height: 22,
    rx: 5,
    fill: "#dcfce7",
    stroke: "#059669",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 490,
    y: 152,
    textAnchor: "middle",
    fontFamily: "system-ui, sans-serif",
    fontSize: 9,
    fontWeight: 600,
    fill: "#064e3b"
  }, "Claude Code"), /*#__PURE__*/React.createElement("rect", {
    x: 452,
    y: 166,
    width: 76,
    height: 22,
    rx: 5,
    fill: "#dcfce7",
    stroke: "#059669",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 490,
    y: 180,
    textAnchor: "middle",
    fontFamily: "system-ui, sans-serif",
    fontSize: 9,
    fontWeight: 600,
    fill: "#064e3b"
  }, "Cursor"), /*#__PURE__*/React.createElement("rect", {
    x: 452,
    y: 194,
    width: 76,
    height: 22,
    rx: 5,
    fill: "#dcfce7",
    stroke: "#059669",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 490,
    y: 208,
    textAnchor: "middle",
    fontFamily: "system-ui, sans-serif",
    fontSize: 9,
    fontWeight: 600,
    fill: "#064e3b"
  }, "..."))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 305,
    textAnchor: "middle",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 600,
    fill: "#064e3b"
  }, "AI developer assistant \xB7 Kalisio")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKalisioKnowledge);
export default __webpack_public_path__ + "static/media/kalisio-knowledge.b995dc607866e129171c1699f1d3cebb.svg";
export { ForwardRef as ReactComponent };